const initialState = {
  homeScreen: {
    title: 'La tapera invisible',
    content: 'El eterno, redundante y cíclico, código recursivo defectuoso.'
  }
}

export default (state = initialState) => state

export const getTitle = state => state.homeScreen.title
export const getContent = state => state.homeScreen.content



/** WEBPACK FOOTER **
 ** ./src/reducers/configuration.js
 **/